export {
  default as waterfall,
  ReactComponent as Waterfall,
} from '@assets/icons/features-and-amenities/waterfall.svg'    
